import { createAction, createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { manageObjectives } from "./manage-objectives";

const initialState: ProcessingState = { processing: "idle" };

export const resetManageObjectives = createAction("student/resetManageObjectives");

export const manageObjectivesReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(manageObjectives.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(manageObjectives.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(manageObjectives.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetManageObjectives, () => {
    return initialState;
  });
});
